<template>
  <div>
    <v-row class="mx-auto px-0 py-0" style="background-color:#f5f5f5"
      ><v-col cols="12" class="px-0 pb-0 pt-2">
        <v-card v-if="overlay" tile style="color:rgb(78, 184, 136);">
          <v-skeleton-loader
            max-width="400"
            class="py-2"
            type="list-item-avatar, list-item-one-line, divider, list-item-three-line, list-item-three-line"
          ></v-skeleton-loader>
        </v-card>
        <v-card v-else-if="date_aggs.length == 0 && !overlay" tile>
          <v-card-text class="text-center py-8">
            <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-line</v-icon>
            <div class="text-h6 grey--text text--lighten-1 mb-2">No Data Available</div>
            <div class="body-2 grey--text">This supplier has no contract data to display.</div>
          </v-card-text>
        </v-card>
        <v-card v-else tile>
          <v-card-title style="color:#12253a;"
            ><span class="d-flex align-center">
              <CompanyLogo
                v-if="entity.website"
                :domain="entity.website"
                :company-name="entity.name"
                size="medium"
                class="mr-3"
              />
              <div>
                <v-card-subtitle class="pa-0 font-weight-light">Supplier</v-card-subtitle>
                <span>{{ entity.name }}</span>
                  <!-- <span v-if="entity.published_name && entity.published_name.trim().toLowerCase() != entity.name.trim().toLowerCase()"> 
                    <span class="title font-weight-light"> (Alt. {{entity.published_name}})</span>
                  </span> -->
                  <div
                    v-if="related_entities.length > 0"
                    class="font-weight-normal subtitle-2"
                  >
                    <a @click="related_dialog = true"
                      >Also known by
                      {{ related_entities.length }} other name<span
                        v-if="related_entities.length > 1"
                        >s</span
                      ><v-icon color="#41a7d9" class="pl-0 ml-0"
                        >mdi-menu-right</v-icon
                      ></a
                    >
                  </div>
              </div>
            </span>
            
            <div class="flex-grow-1 desktop-nav"></div>
            <!-- <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    large
                    icon
                    color="primary"
                    light
                    style="text-decoration: none !important;"
                    @click="openInsightsModal"
                  >
                    <v-icon>mdi-lightbulb-on</v-icon>
                  </v-btn>
                </template>
                <span>View Competitive Insights</span>
              </v-tooltip>
            </span> -->
            <span> 
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                      <cluster-select :large="false" @clearSelections="selected = [], selectAll=false, selectedEntities = []" :disabled="notSelected" :entityType="'supplier'" :entityIDType="'supplier_id'" :entities="selected" :entity-labels="entity.id ? { [entity.id]: entity.name } : {}" />
                  </span>
                </template>
                <span>Add {{ entity.name }} to a cluster</span>
              </v-tooltip>
            </span>
            
            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    large
                    icon
                    color="#4EB888"
                    light
                    style="text-decoration: none !important;"
                    :to="{ name: 'search', query: { supplier_id: entity.id } }"
                  >
                    <v-icon>mdi-format-list-bulleted</v-icon>
                  </v-btn>
                </template>
                <span>View all {{ entity.name }} awards</span>
              </v-tooltip>
            </span>
            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    large
                    icon
                    color="secondary"
                    light
                    style="text-decoration: none !important;"
                    target="_blank"
                    :to="{ name: 'report', query: { supplier_id: entity.id, 
                                                    comparison_sum_value: 'active', 
                                                    comparison_group_value: 'publisher',
                                                    scatter_group_value: 'procurement_method',
                                                    scatter_num_groups: 5} }"
                  >
                    <v-icon>mdi-chart-box-outline</v-icon>
                  </v-btn>
                </template>
                <span>View this supplier's insights report</span>
              </v-tooltip>
            </span>
            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    large
                    icon
                    color="secondary"
                    light
                    style="text-decoration: none !important;"
                    target="_blank"
                    :to="{ name: 'network', query: { supplier_id: entity.id} }"
                  >
                    <v-icon>mdi-graphql</v-icon>
                  </v-btn>
                </template>
                <span>View this supplier's network</span>
              </v-tooltip>
            </span>
            <span>
              <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    large
                    icon
                    color="#4EB888"
                    light
                    :href="entity.website"
                    target="_blank"
                    style="text-decoration: none !important;"
                    :disabled="disableIcon(entity.website)"
                  >
                    <v-icon>mdi-web</v-icon>
                  </v-btn>
                </template>
                <span>Go to Website</span>
              </v-tooltip>
            </span>
            <span v-if="entity.metadata && entity.metadata.linkedin">
                  <v-btn
                    large
                    icon
                    color="#4EB888"
                    light
                    :href="'https://'+entity.metadata.linkedin"
                    target="_blank"
                    style="text-decoration: none !important;"
                  >
                    <v-icon>mdi-linkedin</v-icon>
                  </v-btn>
            </span>
            <span v-if="entity.metadata && entity.metadata.twitter">
                  <v-btn
                    large
                    icon
                    color="#4EB888"
                    light
                    :href="'https://'+entity.metadata.twitter"
                    target="_blank"
                    style="text-decoration: none !important;"
                  >
                    <v-icon>mdi-twitter</v-icon>
                  </v-btn>
            </span>
            
            </v-card-title
          >
          <v-card-subtitle>
            <div
              v-if="entity.company_number"
              style="color:#12253a;"
              class="font-weight-strong"
            >
              <b>ABN</b> {{ entity.company_number }}
            </div>

            <div
              v-if="hasMetadata && entity.metadata.numEmployees && entity.metadata.numEmployees.max"
              style="color:#12253a;"
              class="font-weight-strong"
            >
              <b>STAFF</b> {{getSizeText(entity.metadata.numEmployees.max)}}
            </div>

            <div v-if="entity.metadata" class="font-weight-normal subtitle-2 pt-5 pb-0">
              <a @click="info_dialog = true"
                >Description<v-icon color="#41a7d9" class="pl-0 ml-0"
                  >mdi-menu-right</v-icon
                ></a
              >
            </div>
            <span v-if="hasMetadata && entity.metadata.industry">
              <span v-for="e in entity.metadata.industry" :key="e">
                <router-link target="_blank"
                            :to="{ name: 'industry', query: { supplier_industry: e } }"
                          >
                    <v-chip
                        class="my-1 ml-0 mr-2"
                        color="secondary"
                        label
                        text-color="secondary"
                        small
                        outlined
                  >
                    <v-icon small left>
                      mdi-label
                    </v-icon>
                    {{e}}
                  </v-chip>
                </router-link>
                </span>
            </span>
            <span v-if="hasMetadata && entity.metadata.smartTags">
              <span v-for="e in entity.metadata.smartTags" :key="e">
                <v-chip
                        class="my-1 ml-0 mr-2"
                        color="primary"
                        label
                        text-color="primary"
                        small
                        outlined
                  >
                    <v-icon small left>
                      mdi-tag
                    </v-icon>
                    {{e}}
                  </v-chip>
              </span>
            </span>
            <span v-for="clstr in entity.clusters" :key="clstr.id">
              <router-link target="_blank"
                            :to="{ name: 'cluster', params: { clusterId: clstr.id } }"
                          >
                    <v-chip v-if="clstr"
                      class="my-1 ml-0 mr-2"
                      color="primary"
                      label
                      text-color="primary"
                      small
                      outlined
                    >     
                    <v-icon small left>
                      mdi-hexagon-multiple
                    </v-icon>
                    {{clstr.name}}
                    </v-chip>
              </router-link>
            </span>
            <div
              v-if="hasMetadata && entity.metadata.competitors && entity.metadata.competitors.length > 0"
              class="font-weight-normal subtitle-2 pt-3 pb-0"
            >
              <a @click="similar_dialog = true"
                >Similar companies or competitors<v-icon color="#41a7d9" class="pl-0 ml-0"
                  >mdi-menu-right</v-icon
                ></a
              >
            </div>
            
          </v-card-subtitle>
          
          <!-- <v-dialog
            v-model="show_insights_modal"
            scrollable
            max-width="1400"
          >
            <v-card tile class="pa-4">
              <v-card-title class="d-flex align-center">
                <span class="text-h6 font-weight-bold d-flex align-center" style="color:#12253a;">
                  <v-icon class="mr-2" color="primary">mdi-lightbulb-on</v-icon>
                  Competitive Insights
                </span>
                <v-spacer></v-spacer>
                <v-btn icon @click="show_insights_modal = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-4">
                <div v-if="intelligence_loading" class="text-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="64"
                  ></v-progress-circular>
                  <div class="body-2 grey--text mt-4">Loading competitive insights...</div>
                </div>
                <v-row v-else>
                  <v-col cols="12" md="8">
                        <v-card
                          v-if="supplier_intelligence && supplier_market_overlap && supplier_market_overlap.overlap_percentage"
                          tile
                          class="mb-4"
                          :color="supplier_market_overlap.overlap_score >= 70 ? 'red lighten-5' : supplier_market_overlap.overlap_percentage >= 40 ? 'orange lighten-5' : 'blue lighten-5'"
                          :style="supplier_market_overlap.overlap_score >= 70 ? 'border: 2px solid #f44336;' : supplier_market_overlap.overlap_percentage >= 40 ? 'border: 2px solid #ff9800;' : 'border: 2px solid #2196f3;'"
                        >
                          <v-card-text class="py-3">
                            <div class="d-flex align-start">
                              <v-icon
                                :color="supplier_market_overlap.overlap_score >= 70 ? 'red darken-2' : supplier_market_overlap.overlap_percentage >= 40 ? 'orange darken-2' : 'blue darken-2'"
                                class="mr-3 mt-1"
                                size="24"
                              >
                                mdi-shield-alert
                              </v-icon>
                              <div class="flex-grow-1" style="color:#12253a;">
                                <div class="font-weight-bold mb-1" style="font-size: 16px;">
                                  <span v-if="supplier_market_overlap.overlap_percentage >= 70">🎯 Key Competitor - High Threat Level</span>
                                  <span v-else-if="supplier_market_overlap.overlap_percentage >= 40">⚠️ Competitive Overlap Detected</span>
                                  <span v-else>📊 Market Intelligence</span>
                                </div>
                                <div class="body-2 mb-2">
                                  <span v-if="supplier_market_overlap.overlap_score >= 70">
                                    Direct competitor with {{ supplier_market_overlap.overlap_percentage }}% market overlap.
                                    <span v-if="supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count">
                                      Active in {{ supplier_shared_buyers.shared_buyer_count }} of your customer accounts.
                                    </span>
                                    <span v-if="supplier_intelligence && supplier_intelligence.competitive_threat_score">
                                      Threat Score: {{ supplier_intelligence.competitive_threat_score }}/100
                                    </span>
                                  </span>
                                  <span v-else-if="supplier_market_overlap.overlap_percentage >= 40">
                                    Moderate market overlap ({{ supplier_market_overlap.overlap_percentage }}%) detected.
                                    <span v-if="supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count">
                                      Shares {{ supplier_shared_buyers.shared_buyer_count }} buyers with you.
                                    </span>
                                  </span>
                                  <span v-else>
                                    Market overlap: {{ supplier_market_overlap.overlap_percentage }}%
                                    <span v-if="supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count">
                                      | {{ supplier_shared_buyers.shared_buyer_count }} shared buyers
                                    </span>
                                  </span>
                                </div>
                                <div class="d-flex flex-wrap gap-2">
                                  <v-btn
                                    small
                                    :color="supplier_market_overlap.overlap_percentage >= 70 ? 'red darken-2' : 'primary'"
                                    dark
                                    class="text-capitalize"
                                  >
                                    <v-icon small left>mdi-plus</v-icon>
                                    Add to Competitors
                                  </v-btn>
                                  <v-btn small outlined color="primary" class="text-capitalize">
                                    <v-icon small left>mdi-bell</v-icon>
                                    Set Competitive Alerts
                                  </v-btn>
                                  <v-btn small outlined color="primary" class="text-capitalize">
                                    <v-icon small left>mdi-chart-box</v-icon>
                                    Compare to You
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>

                        <v-card
                          v-if="supplier_market_overlap && supplier_market_overlap.overlap_percentage"
                          tile
                          class="mb-4"
                          style="background: linear-gradient(to right, #e3f2fd, #e8eaf6); border: 1px solid #2196f3;"
                        >
                          <v-card-title class="pb-2" style="color: #12253a;">
                            <span class="text-h6 font-weight-bold">Market Overlap Analysis</span>
                          </v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col cols="12" md="6">
                                <div class="mb-4">
                                  <div class="d-flex justify-space-between align-center mb-2">
                                    <span class="body-1 font-weight-medium" style="color: #12253a;">Market Overlap</span>
                                    <span class="text-h6 font-weight-bold" style="color: #1976d2;">
                                      {{ supplier_market_overlap.overlap_percentage || 0 }}%
                                    </span>
                                  </div>
                                  <v-progress-linear
                                    :value="supplier_market_overlap.overlap_percentage || 0"
                                    :color="supplier_market_overlap.overlap_percentage >= 70 ? 'red' : supplier_market_overlap.overlap_percentage >= 40 ? 'orange' : 'blue'"
                                    height="8"
                                    rounded
                                    class="mb-1"
                                  ></v-progress-linear>
                                  <div class="caption text--secondary">
                                    <span v-if="supplier_market_overlap.shared_categories && supplier_market_overlap.shared_categories > 0">
                                      Compete in {{ supplier_market_overlap.shared_categories }} shared categories
                                    </span>
                                    <span v-else-if="supplier_market_overlap.shared_category_list && supplier_market_overlap.shared_category_list.length > 0">
                                      Compete in: {{ supplier_market_overlap.shared_category_list.slice(0, 3).join(', ') }}
                                    </span>
                                    <span v-else>No category overlap data available</span>
                                  </div>
                                </div>
                                <div v-if="supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count" class="mb-4">
                                  <div class="d-flex align-center mb-2">
                                    <v-icon small color="orange darken-2" class="mr-2">mdi-account-group</v-icon>
                                    <span class="body-1 font-weight-medium" style="color: #12253a;">Shared Buyers</span>
                                    <v-chip
                                      small
                                      :color="supplier_shared_buyers.shared_buyer_count >= 10 ? 'red' : supplier_shared_buyers.shared_buyer_count >= 5 ? 'orange' : 'grey'"
                                      text-color="white"
                                      class="ml-2"
                                    >
                                      {{ supplier_shared_buyers.shared_buyer_count >= 10 ? 'HIGH' : supplier_shared_buyers.shared_buyer_count >= 5 ? 'MEDIUM' : 'LOW' }}
                                    </v-chip>
                                  </div>
                                  <div class="ml-6">
                                    <div class="caption text--secondary">
                                      {{ supplier_shared_buyers.shared_buyer_count }} buyers where you both compete
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div v-if="supplier_market_overlap.overlap_score !== undefined" class="mb-4">
                                  <v-card
                                    :color="supplier_market_overlap.overlap_score >= 70 ? 'red darken-2' : supplier_market_overlap.overlap_score >= 40 ? 'orange darken-2' : 'blue darken-2'"
                                    dark
                                    class="pa-3"
                                  >
                                    <div class="d-flex justify-space-between align-center mb-1">
                                      <span class="body-2 font-weight-medium">Overlap Score</span>
                                      <span class="text-h4 font-weight-bold">{{ supplier_market_overlap.overlap_score }}/100</span>
                                    </div>
                                    <div class="caption" style="opacity: 0.9;">
                                      <span v-if="supplier_market_overlap.overlap_score >= 70">
                                        High overlap - Direct competitor in your core markets
                                      </span>
                                      <span v-else-if="supplier_market_overlap.overlap_score >= 40">
                                        Moderate overlap - Some competitive presence
                                      </span>
                                      <span v-else>
                                        Low overlap - Limited competitive presence
                                      </span>
                                    </div>
                                  </v-card>
                                </div>
                                <div v-if="supplier_intelligence && supplier_intelligence.competitive_threat_score !== undefined" class="mb-4">
                                  <v-card
                                    :color="supplier_intelligence.competitive_threat_score >= 70 ? 'red darken-2' : supplier_intelligence.competitive_threat_score >= 40 ? 'orange darken-2' : 'blue darken-2'"
                                    dark
                                    class="pa-3"
                                  >
                                    <div class="d-flex justify-space-between align-center mb-1">
                                      <span class="body-2 font-weight-medium">Competitive Threat Score</span>
                                      <span class="text-h4 font-weight-bold">{{ supplier_intelligence.competitive_threat_score }}/100</span>
                                    </div>
                                    <div class="caption" style="opacity: 0.9;">
                                      <span v-if="supplier_intelligence.competitive_threat_score >= 70">
                                        High threat - Strong competitor in your core markets
                                      </span>
                                      <span v-else-if="supplier_intelligence.competitive_threat_score >= 40">
                                        Moderate threat - Some competitive overlap
                                      </span>
                                      <span v-else>
                                        Low threat - Limited competitive presence
                                      </span>
                                    </div>
                                  </v-card>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card
                          v-if="supplier_competitive_comparison"
                          tile
                          class="mb-4"
                          style="background: linear-gradient(to right, #fff3e0, #ffe0b2); border: 1px solid #ff9800;"
                        >
                          <v-card-title class="pb-2" style="color: #12253a;">
                            <span class="text-h6 font-weight-bold">Your Competitive Position vs {{ entity.name }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col cols="12" md="6">
                                <div v-if="(supplier_market_overlap && supplier_market_overlap.overlap_percentage) || (supplier_competitive_comparison && supplier_competitive_comparison.market_overlap && supplier_competitive_comparison.market_overlap.overlap_percentage)" class="mb-4">
                                  <div class="d-flex justify-space-between align-center mb-2">
                                    <span class="body-1 font-weight-medium" style="color: #12253a;">Market Overlap</span>
                                    <span class="text-h6 font-weight-bold" style="color: #ff4081;">
                                      {{ (supplier_market_overlap && supplier_market_overlap.overlap_percentage) || (supplier_competitive_comparison && supplier_competitive_comparison.market_overlap && supplier_competitive_comparison.market_overlap.overlap_percentage) || 0 }}%
                                    </span>
                                  </div>
                                  <v-progress-linear
                                    :value="(supplier_market_overlap && supplier_market_overlap.overlap_percentage) || (supplier_competitive_comparison && supplier_competitive_comparison.market_overlap && supplier_competitive_comparison.market_overlap.overlap_percentage) || 0"
                                    :color="((supplier_market_overlap && supplier_market_overlap.overlap_percentage) || (supplier_competitive_comparison && supplier_competitive_comparison.market_overlap && supplier_competitive_comparison.market_overlap.overlap_percentage) || 0) >= 70 ? 'red' : 'orange'"
                                    height="8"
                                    rounded
                                    class="mb-1"
                                  ></v-progress-linear>
                                  <div class="caption text--secondary">
                                    <span v-if="supplier_market_overlap && supplier_market_overlap.shared_categories && supplier_market_overlap.shared_categories > 0">
                                      Compete in {{ supplier_market_overlap.shared_categories }} shared categories
                                    </span>
                                    <span v-else-if="supplier_market_overlap && supplier_market_overlap.shared_category_list && supplier_market_overlap.shared_category_list.length > 0">
                                      Compete for same buyers in: {{ supplier_market_overlap.shared_category_list.slice(0, 3).join(', ') }}
                                    </span>
                                    <span v-else-if="supplier_competitive_comparison && supplier_competitive_comparison.market_overlap && supplier_competitive_comparison.market_overlap.shared_category_list && supplier_competitive_comparison.market_overlap.shared_category_list.length > 0">
                                      Compete for same buyers in: {{ supplier_competitive_comparison.market_overlap.shared_category_list.slice(0, 3).join(', ') }}
                                    </span>
                                    <span v-else-if="supplier_competitive_comparison && supplier_competitive_comparison.market_overlap && supplier_competitive_comparison.market_overlap.shared_categories && supplier_competitive_comparison.market_overlap.shared_categories > 0">
                                      Compete in {{ supplier_competitive_comparison.market_overlap.shared_categories }} shared categories
                                    </span>
                                    <span v-else>No category overlap data available</span>
                                  </div>
                                </div>
                                <div v-if="supplier_competitive_comparison" class="mb-4">
                                  <h4 class="body-2 font-weight-semibold mb-3" style="color: #12253a;">Head-to-Head Performance</h4>
                                  <div class="space-y-2 caption">
                                    <div class="d-flex justify-space-between">
                                      <span style="color: #12253a;">Shared Buyers:</span>
                                      <span class="font-medium" style="color: #12253a;">
                                        {{ supplier_competitive_comparison.shared_buyers || supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count || 0 }} entities
                                      </span>
                                    </div>
                                    <div class="d-flex justify-space-between">
                                      <span style="color: #12253a;">You:</span>
                                      <span class="font-medium" style="color: #41a7d9;">
                                        {{ supplier_competitive_comparison.your_buyer_count || 0 }} buyers
                                      </span>
                                    </div>
                                    <div class="d-flex justify-space-between">
                                      <span style="color: #12253a;">{{ entity.name }}:</span>
                                      <span class="font-medium" style="color: #ff4081;">
                                        {{ supplier_competitive_comparison.their_buyer_count || 0 }} buyers
                                      </span>
                                    </div>
                                    <v-divider class="my-2"></v-divider>
                                    <div class="d-flex justify-space-between">
                                      <span style="color: #12253a;">Avg Contract Value:</span>
                                    </div>
                                    <div class="d-flex justify-space-between">
                                      <span style="color: #12253a;">You:</span>
                                      <span class="font-medium" style="color: #41a7d9;">
                                        {{ formattedCurrency(supplier_competitive_comparison.your_avg_contract || 0) }}
                                      </span>
                                    </div>
                                    <div class="d-flex justify-space-between">
                                      <span style="color: #12253a;">{{ entity.name }}:</span>
                                      <span class="font-medium" style="color: #ff4081;">
                                        {{ formattedCurrency(supplier_competitive_comparison.their_avg_contract || 0) }}
                                        <span v-if="supplier_competitive_comparison.contract_multiplier">
                                          ({{ supplier_competitive_comparison.contract_multiplier.toFixed(1) }}x)
                                        </span>
                                      </span>
                                    </div>
                                    <v-divider v-if="supplier_competitive_comparison.win_rate" class="my-2"></v-divider>
                                    <div v-if="supplier_competitive_comparison.win_rate" class="d-flex justify-space-between">
                                      <span style="color: #12253a;">Win Rate vs You (24mo):</span>
                                    </div>
                                    <div v-if="supplier_competitive_comparison.win_rate" class="d-flex justify-space-between">
                                      <span style="color: #12253a;">{{ entity.name }}:</span>
                                      <span class="font-medium" style="color: #ff4081;">
                                        {{ (supplier_competitive_comparison.win_rate.their_win_rate * 100).toFixed(0) }}%
                                      </span>
                                    </div>
                                    <div v-if="supplier_competitive_comparison.win_rate" class="d-flex justify-space-between">
                                      <span style="color: #12253a;">You:</span>
                                      <span class="font-medium" style="color: #41a7d9;">
                                        {{ (supplier_competitive_comparison.win_rate.your_win_rate * 100).toFixed(0) }}%
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div v-if="supplier_competitive_comparison" class="mb-4">
                                  <h4 class="body-2 font-weight-semibold mb-2" style="color: #12253a;">Their Advantage</h4>
                                  <div class="space-y-1 caption" style="color: #12253a;">
                                    <div v-for="(advantage, idx) in (supplier_competitive_comparison.their_advantages || [])" :key="idx" class="d-flex align-start">
                                      <span style="color: #ff4081; margin-top: 2px; margin-right: 4px;">✓</span>
                                      <span>{{ displayAdvantage(advantage) }}</span>
                                    </div>
                                    <div v-if="!supplier_competitive_comparison.their_advantages || supplier_competitive_comparison.their_advantages.length === 0" class="text--secondary">
                                      No significant advantages detected
                                    </div>
                                  </div>
                                  <h4 class="body-2 font-weight-semibold mt-4 mb-2" style="color: #12253a;">Your Advantage</h4>
                                  <div class="space-y-1 caption" style="color: #12253a;">
                                    <div v-for="(advantage, idx) in (supplier_competitive_comparison.your_advantages || [])" :key="idx" class="d-flex align-start">
                                      <span style="color: #4EB888; margin-top: 2px; margin-right: 4px;">✓</span>
                                      <span>{{ displayAdvantage(advantage) }}</span>
                                    </div>
                                    <div v-if="!supplier_competitive_comparison.your_advantages || supplier_competitive_comparison.your_advantages.length === 0" class="text--secondary">
                                      No significant advantages detected
                                    </div>
                                  </div>
                                </div>
                                <div v-if="supplier_intelligence && supplier_intelligence.competitive_threat_score !== undefined">
                                  <v-card
                                    :color="supplier_intelligence.competitive_threat_score >= 70 ? 'red darken-2' : supplier_intelligence.competitive_threat_score >= 40 ? 'orange darken-2' : 'blue darken-2'"
                                    dark
                                    class="pa-3"
                                  >
                                    <div class="d-flex justify-space-between align-center mb-1">
                                      <span class="body-2 font-weight-medium">Competitive Threat Score</span>
                                      <span class="text-h4 font-weight-bold">{{ supplier_intelligence.competitive_threat_score }}/100</span>
                                    </div>
                                    <div class="caption" style="opacity: 0.9;">
                                      <span v-if="supplier_intelligence.competitive_threat_score >= 70">
                                        High threat - Strong competitor in your core markets
                                      </span>
                                      <span v-else-if="supplier_intelligence.competitive_threat_score >= 40">
                                        Moderate threat - Some competitive overlap
                                      </span>
                                      <span v-else>
                                        Low threat - Limited competitive presence
                                      </span>
                                    </div>
                                  </v-card>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card
                          v-if="(supplier_shared_buyers && supplier_shared_buyers.shared_buyers && supplier_shared_buyers.shared_buyers.length > 0) || (supplier_shared_buyers_risk && supplier_shared_buyers_risk.shared_buyers && supplier_shared_buyers_risk.shared_buyers.length > 0)"
                          tile
                        >
                          <v-card-title class="pb-2" style="color: #12253a;">
                            <span class="text-h6 font-weight-bold">Where You Compete</span>
                          </v-card-title>
                          <v-card-text>
                            <div v-if="supplier_shared_buyers_risk && supplier_shared_buyers_risk.shared_buyers && supplier_shared_buyers_risk.shared_buyers.length > 0" class="mb-4">
                              <v-card outlined class="mb-3" style="border: 2px solid #ff9800;">
                                <v-card-title class="pb-2" style="color: #12253a;">
                                  <span class="subtitle-1 font-weight-bold">
                                    Buyers You Both Serve ({{ supplier_shared_buyers_risk.shared_buyer_count || supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count || 0 }})
                                  </span>
                                </v-card-title>
                                <v-card-text>
                                  <v-list>
                                    <v-list-item
                                      v-for="(buyer, idx) in supplier_shared_buyers_risk.shared_buyers.slice(0, 5)"
                                      :key="idx"
                                      class="mb-2"
                                      :style="buyer.comparison && buyer.comparison.risk_level === 'HIGH' ? 'background-color: #ffebee; border-radius: 4px; border-left: 4px solid #f44336;' : 'background-color: #fff3e0; border-radius: 4px;'"
                                    >
                                      <v-list-item-content>
                                        <div class="d-flex justify-space-between align-center">
                                          <div class="flex-grow-1">
                                            <div class="d-flex align-center mb-1">
                                              <div class="font-weight-medium" style="color: #12253a;">{{ buyer.publisher || buyer.buyer_name }}</div>
                                              <v-chip
                                                v-if="buyer.comparison && buyer.comparison.risk_level"
                                                x-small
                                                :color="buyer.comparison.risk_level === 'HIGH' ? 'red' : buyer.comparison.risk_level === 'MEDIUM' ? 'orange' : 'grey'"
                                                text-color="white"
                                                class="ml-2"
                                              >
                                                Risk: {{ buyer.comparison.risk_level }}
                                              </v-chip>
                                            </div>
                                            <div class="caption text--secondary mb-1">
                                              <span v-if="buyer.comparison">
                                                {{ entity.name }}: {{ formattedCurrency(buyer.comparison.their_revenue || buyer.comparison.their_spend || 0) }}
                                                ({{ buyer.comparison.their_contracts || 0 }} contracts) |
                                                You: {{ formattedCurrency(buyer.comparison.your_revenue || buyer.comparison.your_spend || 0) }}
                                                ({{ buyer.comparison.your_contracts || 0 }} contracts)
                                              </span>
                                              <span v-else>
                                                {{ buyer.contracts || 0 }} contracts |
                                                {{ formattedCurrency(buyer.total_revenue || 0) }} total
                                              </span>
                                            </div>
                                            <div v-if="buyer.comparison && buyer.comparison.risk_reason" class="caption" style="color: #f44336;">
                                              {{ buyer.comparison.risk_reason }}
                                            </div>
                                          </div>
                                          <div class="d-flex flex-column gap-2 ml-4">
                                            <v-btn
                                              small
                                              color="primary"
                                              dark
                                              @click="$router.push({ name: 'buyer', params: { id: buyer.publisher_id || buyer.buyer_id } })"
                                            >
                                              View Profile
                                            </v-btn>
                                            <v-btn
                                              v-if="buyer.comparison && buyer.comparison.risk_level === 'HIGH'"
                                              small
                                              outlined
                                              color="red darken-1"
                                            >
                                              Defense Strategy
                                            </v-btn>
                                          </div>
                                        </div>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                  <div v-if="supplier_shared_buyers_risk.shared_buyers.length > 5" class="text-center pt-2">
                                    <v-btn small text color="primary" @click="openSearchForPublishers(supplier_shared_buyers_risk.shared_buyers)">
                                      View all {{ supplier_shared_buyers_risk.shared_buyer_count || supplier_shared_buyers_risk.shared_buyers.length }} shared buyers →
                                    </v-btn>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>
                            <div v-else-if="supplier_shared_buyers && supplier_shared_buyers.shared_buyers && supplier_shared_buyers.shared_buyers.length > 0" class="mb-4">
                              <v-card outlined class="mb-3" style="border: 2px solid #ff9800;">
                                <v-card-title class="pb-2" style="color: #12253a;">
                                  <span class="subtitle-1 font-weight-bold">Buyers You Both Serve ({{ supplier_shared_buyers.shared_buyer_count }})</span>
                                </v-card-title>
                                <v-card-text>
                                  <v-list>
                                    <v-list-item
                                      v-for="(buyer, idx) in supplier_shared_buyers.shared_buyers.slice(0, 5)"
                                      :key="idx"
                                      class="mb-2"
                                      style="background-color: #fff3e0; border-radius: 4px;"
                                    >
                                      <v-list-item-content>
                                        <div class="d-flex justify-space-between align-center">
                                          <div class="flex-grow-1">
                                            <div class="font-weight-medium mb-1" style="color: #12253a;">{{ buyer.publisher }}</div>
                                            <div class="caption text--secondary">
                                              {{ buyer.contracts }} contracts |
                                              {{ formattedCurrency(buyer.total_revenue) }} total
                                              <span v-if="buyer.active_contracts">
                                                | {{ buyer.active_contracts }} active ({{ formattedCurrency(buyer.active_revenue) }})
                                              </span>
                                            </div>
                                          </div>
                                          <v-btn
                                            small
                                            color="primary"
                                            dark
                                            class="ml-2"
                                            @click="$router.push({ name: 'buyer', params: { id: buyer.publisher_id } })"
                                          >
                                            View
                                          </v-btn>
                                        </div>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                  <div v-if="supplier_shared_buyers.shared_buyers.length > 5" class="text-center pt-2">
                                    <v-btn small text color="primary" @click="openSearchForPublishers(supplier_shared_buyers.shared_buyers)">
                                      View all {{ supplier_shared_buyers.shared_buyer_count }} shared buyers →
                                    </v-btn>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>

                            <div v-if="supplier_at_risk_customers && supplier_at_risk_customers.at_risk_customers && supplier_at_risk_customers.at_risk_customers.length > 0" class="mb-4">
                              <v-card outlined class="mb-3" style="border: 2px solid #f44336;">
                                <v-card-title class="pb-2" style="color: #12253a;">
                                  <span class="subtitle-1 font-weight-bold">
                                    Your Customers They're Targeting ({{ supplier_at_risk_customers.at_risk_count || supplier_at_risk_customers.at_risk_customers.length }})
                                  </span>
                                  <v-chip small color="red" text-color="white" class="ml-2">
                                    DEFENSIVE PRIORITY
                                  </v-chip>
                                </v-card-title>
                                <v-card-text>
                                  <v-list>
                                    <v-list-item
                                      v-for="(customer, idx) in supplier_at_risk_customers.at_risk_customers.slice(0, 5)"
                                      :key="idx"
                                      class="mb-2"
                                      style="background-color: #ffebee; border-radius: 4px;"
                                    >
                                      <v-list-item-content>
                                        <div class="d-flex justify-space-between align-center">
                                          <div class="flex-grow-1">
                                            <div class="font-weight-medium mb-1" style="color: #12253a;">{{ customer.buyer_name || customer.publisher }}</div>
                                            <div class="caption text--secondary mb-1">
                                              <span v-if="customer.your_revenue">
                                                Your relationship: {{ formattedCurrency(customer.your_revenue) }}/yr
                                              </span>
                                              <span v-if="customer.their_revenue">
                                                | Their foothold: {{ formattedCurrency(customer.their_revenue) }}
                                              </span>
                                              <span v-if="customer.activity_type">
                                                | {{ customer.activity_type === 'first_win' ? 'First win' : customer.activity_type === 'recent_bid' ? 'Recent bid' : 'Activity detected' }}
                                              </span>
                                            </div>
                                            <div v-if="customer.risk_level" class="caption">
                                              <v-chip
                                                x-small
                                                :color="customer.risk_level === 'HIGH' ? 'red' : customer.risk_level === 'MEDIUM' ? 'orange' : 'grey'"
                                                text-color="white"
                                              >
                                                Risk: {{ customer.risk_level }}
                                              </v-chip>
                                            </div>
                                          </div>
                                          <v-btn
                                            small
                                            color="red darken-1"
                                            dark
                                            class="ml-2"
                                            @click="$router.push({ name: 'buyer', params: { id: customer.buyer_id || customer.publisher_id } })"
                                          >
                                            View Account
                                          </v-btn>
                                        </div>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                  <div v-if="supplier_at_risk_customers.at_risk_customers.length > 5" class="text-center pt-2">
                                    <v-btn small text color="primary" @click="openSearchForPublishers(supplier_at_risk_customers.at_risk_customers)">
                                      View all {{ supplier_at_risk_customers.at_risk_count || supplier_at_risk_customers.at_risk_customers.length }} at-risk customers →
                                    </v-btn>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>

                            <div v-if="supplier_targeting_opportunities && supplier_targeting_opportunities.opportunities && supplier_targeting_opportunities.opportunities.length > 0">
                              <v-card outlined class="mb-3" style="border: 2px solid #4EB888;">
                                <v-card-title class="pb-2" style="color: #12253a;">
                                  <span class="subtitle-1 font-weight-bold">
                                    Their Customers You Could Target ({{ supplier_targeting_opportunities.opportunity_count || supplier_targeting_opportunities.opportunities.length }})
                                  </span>
                                  <v-chip small color="green" text-color="white" class="ml-2">
                                    OFFENSIVE OPPORTUNITY
                                  </v-chip>
                                </v-card-title>
                                <v-card-text>
                                  <v-list>
                                    <v-list-item
                                      v-for="(opp, idx) in supplier_targeting_opportunities.opportunities.slice(0, 5)"
                                      :key="idx"
                                      class="mb-2"
                                      style="background-color: #e8f5e9; border-radius: 4px;"
                                    >
                                      <v-list-item-content>
                                        <div class="d-flex justify-space-between align-center">
                                          <div class="flex-grow-1">
                                            <div class="d-flex align-center mb-1">
                                              <v-icon small color="green darken-2" class="mr-2">mdi-target</v-icon>
                                              <div class="font-weight-medium" style="color: #12253a;">{{ opp.buyer_name || opp.publisher }}</div>
                                            </div>
                                            <div class="caption text--secondary mb-1">
                                              <span v-if="opp.their_revenue">
                                                {{ entity.name }} position: {{ formattedCurrency(opp.their_revenue) }}/yr
                                              </span>
                                              <span v-if="opp.opportunity_value_in_your_categories">
                                                | Your fit: {{ formattedCurrency(opp.opportunity_value_in_your_categories) }}/yr in your categories
                                              </span>
                                              <span v-if="opp.market_fit_pct">
                                                | {{ opp.market_fit_pct }}% match
                                              </span>
                                            </div>
                                            <div class="caption" style="color: #4EB888;">
                                              <span v-if="opp.gap_description">{{ opp.gap_description }}</span>
                                              <span v-else>Opportunity: {{ formattedCurrency(opp.opportunity_value_in_your_categories || 0) }} potential</span>
                                            </div>
                                          </div>
                                          <v-btn
                                            small
                                            color="green darken-1"
                                            dark
                                            class="ml-2"
                                            @click="$router.push({ name: 'buyer', params: { id: opp.buyer_id || opp.publisher_id } })"
                                          >
                                            Analyze
                                          </v-btn>
                                        </div>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                  <div class="d-flex gap-2 mt-3">
                                    <v-btn small color="green darken-1 mr-2" dark @click="openSearchForPublishers(supplier_targeting_opportunities.opportunities)">
                                      See All Opportunities
                                    </v-btn>
                                    <v-btn small outlined color="green darken-1" @click="openSearchForPublishers(supplier_targeting_opportunities.opportunities)">
                                      Build Target List
                                    </v-btn>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card tile height="100%">
                          <v-card-title class="d-flex align-center" style="background-color: #12253a; color: white;">
                            <span class="text-subtitle-1 font-weight-bold">Insights</span>
                          </v-card-title>
                          <v-divider></v-divider>
                          <v-card-text style="max-height: 100%; overflow-y: auto;">
                            <div v-if="supplier_intelligence || supplier_market_overlap || supplier_competitive_insights">
                              <v-card
                                v-if="supplier_intelligence && supplier_intelligence.yoy_changes && supplier_intelligence.yoy_changes.revenue_pct && Math.abs(supplier_intelligence.yoy_changes.revenue_pct) > 20"
                                class="mb-3"
                                :color="supplier_intelligence.yoy_changes.revenue_pct > 0 ? 'orange lighten-5' : 'blue lighten-5'"
                                outlined
                                style="border: 1px solid #ff9800;"
                              >
                                <v-card-text class="py-3">
                                  <div class="d-flex align-start">
                                    <v-icon
                                      :color="supplier_intelligence.yoy_changes.revenue_pct > 0 ? 'orange darken-2' : 'blue darken-2'"
                                      class="mr-2 mt-1"
                                    >
                                      {{ supplier_intelligence.yoy_changes.revenue_pct > 0 ? 'mdi-fire' : 'mdi-trending-down' }}
                                    </v-icon>
                                    <div>
                                      <div class="font-weight-semibold mb-1" style="color: #12253a;">
                                        {{ supplier_intelligence.yoy_changes.revenue_pct > 0 ? '🔥 Hot Signal' : '📈 Trend Alert' }}
                                      </div>
                                      <div class="caption" style="color: #12253a;">
                                        <span v-if="supplier_intelligence.yoy_changes.revenue_pct > 0">
                                          Activity surge: {{ Math.abs(supplier_intelligence.yoy_changes.revenue_pct).toFixed(1) }}% more revenue this year vs last
                                        </span>
                                        <span v-else>
                                          Revenue dropped {{ Math.abs(supplier_intelligence.yoy_changes.revenue_pct).toFixed(1) }}% - Market shift?
                                        </span>
                                      </div>
                                      <div class="caption text--secondary mt-1">
                                        → {{ supplier_intelligence.yoy_changes.revenue_pct > 0 ? 'Expanding market presence' : 'Monitor for opportunities' }}
                                      </div>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>

                              <v-card
                                v-if="supplier_market_overlap && supplier_market_overlap.overlap_score >= 40"
                                class="mb-3"
                                color="red lighten-5"
                                outlined
                                style="border: 1px solid #f44336;"
                              >
                                <v-card-text class="py-3">
                                  <div class="d-flex align-start">
                                    <v-icon color="red darken-2" class="mr-2 mt-1">mdi-shield-alert</v-icon>
                                    <div>
                                      <div class="font-weight-semibold mb-2" style="color: #12253a;">📈 Threat Assessment</div>
                                      <div class="flex items-center justify-between mb-1">
                                        <span class="caption" style="color: #12253a;">Threat Level</span>
                                        <v-chip
                                          x-small
                                          :color="supplier_market_overlap.overlap_score >= 70 ? 'red' : 'orange'"
                                          text-color="white"
                                        >
                                          {{ supplier_market_overlap.overlap_score >= 70 ? 'HIGH' : 'MEDIUM' }}
                                        </v-chip>
                                      </div>
                                      <ul class="caption" style="color: #12253a; padding-left: 16px;">
                                        <li>{{ supplier_market_overlap.overlap_score }}% market overlap</li>
                                        <li v-if="supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count">
                                          {{ supplier_shared_buyers.shared_buyer_count }} shared buyers
                                        </li>
                                        <li v-if="supplier_market_overlap.shared_categories">
                                          {{ supplier_market_overlap.shared_categories }} shared categories
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>

                              <v-card
                                v-if="supplier_intelligence && supplier_intelligence.buyer_analysis && supplier_intelligence.buyer_analysis.opportunity_buyers && supplier_intelligence.buyer_analysis.opportunity_buyers.length > 0"
                                class="mb-3"
                                color="green lighten-5"
                                outlined
                                style="border: 1px solid #4EB888;"
                              >
                                <v-card-text class="py-3">
                                  <div class="d-flex align-start">
                                    <v-icon color="green darken-2" class="mr-2 mt-1">mdi-target</v-icon>
                                    <div>
                                      <div class="font-weight-semibold mb-1" style="color: #12253a;">🎯 Strategic Recommendation</div>
                                      <div class="caption" style="color: #12253a;">
                                        {{ supplier_intelligence.buyer_analysis.opportunity_buyers.length }} buyers they serve that you could target
                                      </div>
                                      <div class="caption text--secondary mt-1">
                                        → Build entry strategy for these accounts
                                      </div>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>

                              <v-card
                                v-if="supplier_market_overlap && supplier_market_overlap.overlap_score < 40 && supplier_shared_buyers && supplier_shared_buyers.shared_buyer_count > 0"
                                class="mb-3"
                                color="blue lighten-5"
                                outlined
                                style="border: 1px solid #41a7d9;"
                              >
                                <v-card-text class="py-3">
                                  <div class="d-flex align-start">
                                    <v-icon color="blue darken-2" class="mr-2 mt-1">mdi-handshake</v-icon>
                                    <div>
                                      <div class="font-weight-semibold mb-1" style="color: #12253a;">💼 Partnership Potential?</div>
                                      <div class="caption" style="color: #12253a;">
                                        Low overlap but {{ supplier_shared_buyers.shared_buyer_count }} shared buyers - complementary services?
                                      </div>
                                      <div class="caption text--secondary mt-1">
                                        → Explore partnership model
                                      </div>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>

                              <div v-if="supplier_competitive_insights">
                                <v-card
                                  v-for="(alert, idx) in (supplier_competitive_insights.critical_alerts || [])"
                                  :key="'alert-' + idx"
                                  class="mb-3"
                                  :color="alert.severity === 'HIGH' ? 'red lighten-5' : 'orange lighten-5'"
                                  outlined
                                  :style="'border: 1px solid ' + (alert.severity === 'HIGH' ? '#f44336' : '#ff9800') + ';'"
                                >
                                  <v-card-text class="py-3">
                                    <div class="d-flex align-start">
                                      <v-icon
                                        :color="alert.severity === 'HIGH' ? 'red darken-2' : 'orange darken-2'"
                                        class="mr-2 mt-1"
                                      >
                                        mdi-alert-circle
                                      </v-icon>
                                      <div>
                                        <div class="font-weight-semibold mb-1" style="color: #12253a;">{{ alert.title || 'Critical Alert' }}</div>
                                        <div class="caption" style="color: #12253a;">{{ alert.message || alert.description }}</div>
                                        <div v-if="alert.action" class="caption text--secondary mt-1">→ {{ alert.action }}</div>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <v-card
                                  v-for="(rec, idx) in (supplier_competitive_insights.strategic_recommendations || [])"
                                  :key="'rec-' + idx"
                                  class="mb-3"
                                  color="green lighten-5"
                                  outlined
                                  style="border: 1px solid #4EB888;"
                                >
                                  <v-card-text class="py-3">
                                    <div class="d-flex align-start">
                                      <v-icon color="green darken-2" class="mr-2 mt-1">mdi-target</v-icon>
                                      <div>
                                        <div class="font-weight-semibold mb-1" style="color: #12253a;">🎯 {{ rec.title || 'Strategic Recommendation' }}</div>
                                        <div class="caption" style="color: #12253a;">{{ rec.message || rec.description }}</div>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <v-card
                                  v-if="supplier_competitive_insights.similar_competitors && supplier_competitive_insights.similar_competitors.length > 0"
                                  class="mb-3"
                                  color="grey lighten-5"
                                  outlined
                                  style="border: 1px solid #9e9e9e;"
                                >
                                  <v-card-text class="py-3">
                                    <div class="mb-2">
                                      <div class="font-weight-semibold mb-3" style="color: #12253a;">🔄 Similar Competitors</div>
                                      <div class="space-y-2">
                                        <v-btn
                                          v-for="(comp, idx) in supplier_competitive_insights.similar_competitors.slice(0, 3)"
                                          :key="idx"
                                          small
                                          text
                                          block
                                          class="text-left justify-start"
                                          style="background-color: white; border: 1px solid #e0e0e0;"
                                          @click="$router.push({ name: 'supplier', params: { id: comp.supplier_id } })"
                                        >
                                          • {{ comp.supplier_name || comp.name }}
                                        </v-btn>
                                      </div>
                                      <v-btn small text color="primary" class="mt-2">Compare All →</v-btn>
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </div>
                            </div>
                            <div v-else class="text-center py-8">
                              <v-icon large color="grey lighten-1" class="mb-4">mdi-lightbulb-outline</v-icon>
                              <div class="body-2 grey--text">No insights available</div>
                            </div>
                          </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog> -->

          <v-row class="ma-0 pa-0">
            <v-divider></v-divider>
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal" >Active Contracts</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">
                  
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title
                        class="font-weight-normal body-2"
                        style="color:#12253a;"
                        >Value</v-card-title
                      >
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(entity.active_contracts.stats.sum) }}
                        </div>
                        <div class="font-weight-normal body-2">
                          <router-link
                            :to="{
                                name: 'search',
                                query: {
                                  supplier_id: entity.id,
                                  disposition: ['Contract Notice','Grant'],
                                  expiry_date_from: new Date().toISOString().split('T')[0],
                                  expiry_date_to: new Date(new Date().getFullYear() + 50, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0],
                                  sort_order: 'asc'
                                }
                              }"
                          >
                            {{ entity.active_contracts.stats.count}}
                            contracts</router-link
                          >
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                
                  <v-col cols="4"  class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title
                        class="font-weight-normal body-2"
                        style="color:#12253a;"
                        >Highest Value</v-card-title
                      >
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(entity.active_contracts.stats.max) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          Contract
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>

                  <v-col cols="4"  class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title
                        class="font-weight-normal body-2"
                        style="color:#12253a;"
                        >Avg Contract</v-card-title
                      >
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(entity.active_contracts.stats.avg) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          Active
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal" >Awards - All Time</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">
                  
                  <v-col cols="4" class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title
                        class="font-weight-normal body-2"
                        style="color:#12253a;"
                        >Value</v-card-title
                      >
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(entity.award_total) }}
                        </div>
                        <div class="font-weight-normal body-2">
                          <router-link
                            :to="{ name: 'search', query: { supplier_id: entity.id } }"
                          >
                            {{ entity.num_notices
                            }}<span v-if="entity.num_notices == 10000">+</span>
                            awards</router-link
                          >
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                
                  <v-col cols="4"  class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title
                        class="font-weight-normal body-2"
                        style="color:#12253a;"
                        >Avg Per Year</v-card-title
                      >
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(entity.award_total / date_aggs.length) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          {{date_aggs.length}} years
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>

                  <v-col cols="4"  class="ma-0 pa-0">
                    <v-card tile flat class="py-0 my-0">
                      <v-card-title
                        class="font-weight-normal body-2"
                        style="color:#12253a;"
                        >Avg Contract</v-card-title
                      >
                      <v-card-subtitle>
                        <div class="font-weight-medium text-h6" style="color:#12253a;">
                          {{ formattedCurrency(avg_contract) }}
                        </div>
                        <div class="font-weight-normal body-2" style="color:#12253a;">
                          All contracts
                        </div>
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal">Awards - Last 12 Months</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">
                <v-col cols="4"  class="ma-0 pa-0">
                  <v-card tile flat class="py-0 my-0">
                    <v-card-title
                      class="font-weight-normal body-2"
                      style="color:#12253a;"
                      >Value</v-card-title 
                    >
                    <v-card-subtitle>
                      <div class="font-weight-medium text-h6" style="color:#12253a;">
                        {{ formattedCurrency(entity.growth.current_year_total) }}
                      </div>
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <v-icon :color="growth_format(entity.growth.spend_change_percent).color">
                          {{growth_format(entity.growth.spend_change_percent).icontype}}
                        </v-icon>
                        {{ growth_format(entity.growth.spend_change_percent).change }}%
                      </div>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="4"  class="ma-0 pa-0">
                  <v-card tile flat class="py-0 my-0">
                    <v-card-title
                      class="font-weight-normal body-2"
                        style="color:#12253a;"
                      >Avg Contract</v-card-title 
                    >
                    <v-card-subtitle>
                      <div class="font-weight-medium text-h6" style="color:#12253a;">
                        {{ formattedCurrency(entity.growth.curr_yr_avg_contract) }}
                      </div>
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <v-icon :color="growth_format(entity.growth.avg_change_percent).color">
                          {{growth_format(entity.growth.avg_change_percent).icontype}}
                        </v-icon>
                        {{ growth_format(entity.growth.avg_change_percent).change }}%
                      </div>
                    </v-card-subtitle>
                  </v-card>
                </v-col> 
                <v-col cols="4"  class="ma-0 pa-0">
                  <v-card tile flat class="py-0 my-0">
                    <v-card-title
                      class="font-weight-normal body-2"
                        style="color:#12253a;"
                      >Contracts</v-card-title 
                    >
                    <v-card-subtitle>
                      <div class="font-weight-medium text-h6" style="color:#12253a;">
                        <router-link
                           :to="{
                              name: 'search',
                              query: {
                                supplier_id: entity.id,
                                disposition: ['Contract Notice','Grant'],
                                contract_start_to: new Date().toISOString().split('T')[0],
                                contract_start_from: new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0],
                                sort_order: 'asc'
                              }
                            }"
                          >
                            {{ numFormatter(entity.growth.current_year_vol) }}
                        </router-link>
                      </div>
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <v-icon :color="growth_format(entity.growth.vol_change_percent).color">
                          {{ growth_format(entity.growth.vol_change_percent).icontype }}
                        </v-icon>
                        {{ growth_format(entity.growth.vol_change_percent).change }}%
                      </div>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="ma-0 pa-0">
              <v-card flat>
                <v-card-text class="pt-2 pb-0 font-weight-normal">Expiring - Next 12 Months</v-card-text>
                <v-divider class="mx-3"></v-divider>
                <v-row class="ma-0 pa-0">
                <v-col cols="4"  class="ma-0 pa-0">
                  <v-card tile flat class="py-0 my-0">
                    <v-card-title
                      class="font-weight-normal body-2"
                        style="color:#12253a;"
                      >Value</v-card-title 
                    >
                    <v-card-subtitle>
                      <div class="font-weight-medium text-h6" style="color:#12253a;">
                        {{ formattedCurrency(entity.expiring_soon.next_year_total) }}
                      </div>
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <v-icon :color="growth_format(entity.expiring_soon.spend_change_percent).color">
                          {{growth_format(entity.expiring_soon.spend_change_percent).icontype}}
                        </v-icon>
                        {{ growth_format(entity.expiring_soon.spend_change_percent).change }}%
                      </div>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="4"  class="ma-0 pa-0">
                  <v-card tile flat class="py-0 my-0">
                    <v-card-title
                      class="font-weight-normal body-2"
                      style="color:#12253a;"
                      >Avg Contract</v-card-title 
                    >
                    <v-card-subtitle>
                      <div class="font-weight-medium text-h6" style="color:#12253a;">
                        {{ formattedCurrency(entity.expiring_soon.next_yr_avg_contract) }}
                      </div>
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <v-icon :color="growth_format(entity.expiring_soon.avg_change_percent).color">
                          {{growth_format(entity.expiring_soon.avg_change_percent).icontype}}
                        </v-icon>
                        {{ growth_format(entity.expiring_soon.avg_change_percent).change }}%
                      </div>
                    </v-card-subtitle>
                  </v-card>
                </v-col> 
                <v-col cols="4"  class="ma-0 pa-0">
                  <v-card tile flat class="py-0 my-0">
                    <v-card-title
                      class="font-weight-normal body-2"
                        style="color:#12253a;"
                      >Contracts</v-card-title 
                    >
                    <v-card-subtitle>
                      <div class="font-weight-medium text-h6" style="color:#12253a;">
                        <router-link
                           :to="{
                              name: 'search',
                              query: {
                                supplier_id: entity.id,
                                disposition: ['Contract Notice','Grant'],
                                contract_end_to: new Date().toISOString().split('T')[0],
                                contract_end_from: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0],
                                sort_order: 'asc'
                              }
                            }"
                          >
                            {{ numFormatter(entity.expiring_soon.next_year_vol) }}
                        </router-link>
                        
                      </div>
                      <div class="font-weight-normal body-2" style="color:#12253a;">
                        <v-icon :color="growth_format(entity.expiring_soon.vol_change_percent).color">
                          {{ growth_format(entity.expiring_soon.vol_change_percent).icontype }}
                        </v-icon>
                        {{ growth_format(entity.expiring_soon.vol_change_percent).change }}%
                      </div>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          
          
        </v-card>
      </v-col>
    </v-row>
    <v-tabs class="pt-4 pb-1" color="rgb(18, 37, 58)" show-arrows>
      <v-tabs-slider color="rgb(255, 20, 99)"></v-tabs-slider>
      <v-tab>
        Analysis
      </v-tab>
      <v-tab>
        Recent Awards
      </v-tab>
      <v-tab @click="selectedFilter = 'all_entities', updateBuyerList({'supplier_id': [entity.id]}), getBuyerStats(entity.id)">
        Buyers
      </v-tab>
      <v-tab @click="selectedFilter = 'common_entities', updateBuyerList({'supplier_id': [entity.id],
                                                          'result_filter': 
                                                            { 'filter_name': 'common_entities', 
                                                              'filter_target_type': 'supplier', 
                                                              'filter_target_id': [entity.id]}}), getBuyerStats(entity.id)">
        Account Overlaps
      </v-tab>
      <v-tab>
        Categories
      </v-tab>
      <v-tab v-if="entity && entity.entity_amendment_rollup">
        Amendments
      </v-tab>
        <v-tab-item>
          <v-row class="py-3">
            <v-col
              cols="12"
              sm="7"
              class="pl-md-3 pr-md-1 py-md-1 px-xs-0 py-xs-0"
            >
              <v-card tile flat>
                <spending-timeline
                  v-if="!overlay && date_aggs.length > 0"
                  :date_aggs="date_aggs"
                  :entity_aggs="publisher_aggs"
                  :expiry_aggs="expiry_aggs"
                  :contracting_activity="contracting_activity"
                  :expiring_activity="expiring_activity"
                  :annual_spend="annual_spend"
                  :entity_type="'publisher'"
                  :metric_name="'total_amount'"
                  :units="'Amount'"
                  :title="'Awards Over Time - Top Buyers'"
                  :supplier_id="entity.id"
                />
                <div v-else-if="overlay" class="text-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="48"
                  ></v-progress-circular>
                  <div class="body-2 grey--text mt-2">Loading chart data...</div>
                </div>
                <div v-else class="text-center py-8">
                  <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-line</v-icon>
                  <div class="body-2 grey--text">No data available for this chart</div>
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="pl-md-1 pr-md-1 py-md-1 px-xs-0 py-xs-0"
            >
              <v-card tile flat>
                <graph-data-view :chartGroup="'publisher'" />
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              class="pl-md-1 pr-md-3 py-md-1 px-xs-0 py-xs-0"
            >
              <v-card tile flat>
                <spending-donut
                  v-if="!overlay && publisher_aggs.length > 0"
                  :entity_type="'publisher'"
                  :metric_name="'total_amount'"
                  :search="search_terms"
                  :entity_data="publisher_aggs"
                  :title="'Total By Buyer'"
                />
                <div v-else-if="overlay" class="text-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="48"
                  ></v-progress-circular>
                  <div class="body-2 grey--text mt-2">Loading chart data...</div>
                </div>
                <div v-else class="text-center py-8">
                  <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-donut</v-icon>
                  <div class="body-2 grey--text">No data available for this chart</div>
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="7"
              class="pl-md-3 pr-md-1 py-md-1 px-xs-0 py-xs-0"
            >
              <v-card tile flat>
                <spending-timeline
                  v-if="!overlay && date_aggs.length > 0"
                  :date_aggs="date_aggs"
                  :expiry_aggs="expiry_aggs"
                  :contracting_activity="contracting_activity"
                  :expiring_activity="expiring_activity"
                  :entity_aggs="category_aggs"
                  :annual_spend="annual_spend"
                  :entity_type="'major_category'"
                  :metric_name="'total_amount'"
                  :units="'Amount'"
                  :title="'Awards Over Time - Top Categories'"
                  :supplier_id="entity.id"
                />
                <div v-else-if="overlay" class="text-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="48"
                  ></v-progress-circular>
                  <div class="body-2 grey--text mt-2">Loading chart data...</div>
                </div>
                <div v-else class="text-center py-8">
                  <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-line</v-icon>
                  <div class="body-2 grey--text">No data available for this chart</div>
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="pl-md-1 pr-md-1 py-md-1 px-xs-0 py-xs-0"
            >
              <v-card tile flat>
                <graph-data-view :chartGroup="'parent_category'" />
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              class="pl-md-1 pr-md-3 py-md-1 px-xs-0 py-xs-0"
            >
              <v-card tile flat>
                <spending-donut
                  v-if="!overlay && category_aggs.length > 0"
                  :entity_type="'major_category'"
                  :metric_name="'total_amount'"
                  :search="search_terms"
                  :entity_data="category_aggs"
                  :title="'Total By Category'"
                />
                <div v-else-if="overlay" class="text-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="48"
                  ></v-progress-circular>
                  <div class="body-2 grey--text mt-2">Loading chart data...</div>
                </div>
                <div v-else class="text-center py-8">
                  <v-icon large color="grey lighten-1" class="mb-4">mdi-chart-donut</v-icon>
                  <div class="body-2 grey--text">No data available for this chart</div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row style="background-color:#f5f5f5">
            <v-col cols="12" class="pt-3">
              <results-table-vuetify
                class="pb-3 pt-0 pl-0 pr-0"
                :hit_info="hit_info"
                :tenders="tenders"
                :hide_pagination="true"
              />
              <v-overlay absolute="true" :value="overlay">
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
            <v-row style="background-color:#f5f5f5">
              <v-col cols="12" md="12" class="mt-1 pt-3 pb-1">
                <v-card v-if="buyer_stats_loaded" flat tile width="100%">
                  <v-card flat tile width="100%">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="2"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                              style="color:#12253a;"
                            >Total</v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a 
                                :class="filterColour ('all_entities')"
                                @click="selectedFilter = 'all_entities', updateBuyerList({'supplier_id': [entity.id]})">
                                {{ buyer_stats.total_buyers }}</a>
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              Buyers
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                      <v-col cols="2"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                              style="color:#12253a;"
                            >Current</v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a 
                                :class="filterColour ('current_entities')"
                                @click="selectedFilter = 'current_entities', updateBuyerList({'supplier_id': [entity.id], 
                                                            expiry_date_from: new Date().toISOString().split('T')[0],
                                                            expiry_date_to: new Date(new Date().getFullYear() + 100, new Date().getMonth(), new Date().getDate()).toISOString().split('T')[0]})">
                                                            {{ buyer_stats.current_buyers }}                           
                              </a>
                              
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              Buyers
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                      <v-col cols="2"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                            style="color:#12253a;"
                            >New - 12 Months</v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a v-if="buyer_stats.current_year > 0"
                                :class="filterColour ('new_entities_ytd')"
                                @click="selectedFilter = 'new_entities_ytd', updateBuyerList({'supplier_id': [entity.id],
                                                            'result_filter': 
                                                              { 'filter_name': 'new_entities_ytd', 
                                                                'filter_target_type': 'supplier', 
                                                                'filter_target_id': [entity.id]}})">
                                {{ buyer_stats.current_year }}                          
                              </a>
                              <span v-else>0</span>
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              <v-icon :color="growth_format(buyer_stats.per_change).color">
                                {{growth_format(buyer_stats.per_change).icontype}}
                              </v-icon>
                              {{ growth_format(buyer_stats.per_change).change }}%
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                      <v-col cols="2"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                              style="color:#12253a;"
                            ><span>Repeat Buyers</span>
                            <v-tooltip left max-width="250">
                              <template v-slot:activator="{ on }">
                                <v-btn x-small v-on="on" icon target="_blank" href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                  <v-icon  small color="primary">mdi-information-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Buyers that have contracted more than once with this supplier.</span
                                >
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more information.
                            </v-tooltip>
                            </v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a v-if="buyer_stats.num_buyers_with_multiple_deals > 0"
                                :class="filterColour ('repeat_entities')"
                                @click="selectedFilter = 'repeat_entities', updateBuyerList({'supplier_id': [entity.id],
                                                            'result_filter': 
                                                              { 'filter_name': 'repeat_entities', 
                                                                'filter_target_type': 'supplier', 
                                                                'filter_target_id': [entity.id]}})">
                                {{ growth_format(Math.round(buyer_stats.num_buyers_with_multiple_deals / buyer_stats.total_buyers * 100)).change }}%                          
                              </a>
                              <span v-else>0</span>
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              {{ buyer_stats.num_buyers_with_multiple_deals }}
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                      <v-col cols="2"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                              style="color:#12253a;"
                            ><span>Exclusive Buyers</span>
                            <v-tooltip left max-width="250">
                              <template v-slot:activator="{ on }">
                                <v-btn x-small v-on="on" icon target="_blank" href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                  <v-icon  small color="primary">mdi-information-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Buyers that have only contracted with this entity.</span
                                >
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more information.
                            </v-tooltip>
                            </v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a v-if="buyer_stats.sole_source_count > 0"  
                              
                                :class="filterColour ('exclusive_entities')"
                                @click="selectedFilter = 'exclusive_entities', updateBuyerList({'supplier_id': [entity.id],
                                                            'result_filter': 
                                                              { 'filter_name': 'exclusive_entities', 
                                                                'filter_target_type': 'supplier', 
                                                                'filter_target_id': [entity.id]}})">
                              {{ growth_format(Math.round(buyer_stats.sole_source_count / buyer_stats.total_buyers * 100)).change }}%</a>
                              
                              <span v-else>{{buyer_stats.sole_source_count}}</span>
                              
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              {{ buyer_stats.sole_source_count }}
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>
              <v-col cols="12" class="pt-0">
                  <profile-members 
                      :startIndex="0" 
                      :profile_id="entity.id"
                      :profile_name="entity.name"
                      :profile_type="'supplier'" 
                      :entity_type="'publisher'" 
                      :key="buyer_list_change"
                      :query="buyer_list_query.query"></profile-members>
              </v-col>
            </v-row>
        </v-tab-item>
        <v-tab-item>
            <v-row style="background-color:#f5f5f5">
              <v-col cols="12" md="12" class="mt-1 pt-3 pb-1">
                <v-card v-if="buyer_stats_loaded" flat tile width="100%">
                  <v-card flat tile width="100%">
                    <v-row class="ma-0 pa-0">
                      <v-col cols="2"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                              style="color:#12253a;"
                            ><span>Common Accounts</span>
                            <v-tooltip left max-width="250">
                              <template v-slot:activator="{ on }">
                                <v-btn x-small v-on="on" icon target="_blank" href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                  <v-icon  small color="primary">mdi-information-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Past or present customers of {{ entity.name }} that have also had contracts with my company.</span
                                >
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more information.
                            </v-tooltip>
                            </v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a v-if="buyer_stats.common_entities > 0"  
                              
                                :class="filterColour ('common_entities')"
                                @click="selectedFilter = 'common_entities', updateBuyerList({'supplier_id': [entity.id],
                                                            'result_filter': 
                                                              { 'filter_name': 'common_entities', 
                                                                'filter_target_type': 'supplier', 
                                                                'filter_target_id': [entity.id]}})">
                              {{ growth_format(Math.round(buyer_stats.common_entities / buyer_stats.total_buyers * 100)).change }}%</a>
                              
                              <span v-else>{{buyer_stats.common_entities}}</span>
                              
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              {{ buyer_stats.common_entities }}
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                      <v-col cols="3"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                              style="color:#12253a;"
                            ><span>Accounts in my prospect lists</span>
                            <v-tooltip left max-width="250">
                              <template v-slot:activator="{ on }">
                                <v-btn x-small v-on="on" icon target="_blank" href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                  <v-icon  small color="primary">mdi-information-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Past or present customers of {{ entity.name }} that are in my prospect lists</span
                                >
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more information.
                            </v-tooltip>
                            </v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a v-if="buyer_stats.prospect_list_accounts > 0"  
                              
                                :class="filterColour ('prospect_list_accounts')"
                                @click="selectedFilter = 'prospect_list_accounts', updateBuyerList({'supplier_id': [entity.id],
                                                            'result_filter': 
                                                              { 'filter_name': 'prospect_list_accounts', 
                                                                'filter_target_type': 'supplier', 
                                                                'filter_target_id': [entity.id]}})">
                              {{ growth_format(Math.round(buyer_stats.prospect_list_accounts / buyer_stats.total_buyers * 100)).change }}%</a>
                              
                              <span v-else>{{buyer_stats.prospect_list_accounts}}</span>
                              
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              {{ buyer_stats.prospect_list_accounts }}
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                      <v-col cols="3"  class="ma-0 pa-0">
                        <v-card tile flat class="py-0 my-0">
                          <v-card-title
                            class="font-weight-normal body-2"
                              style="color:#12253a;"
                            ><span>Accounts in my buyer clusters</span>
                            <v-tooltip left max-width="250">
                              <template v-slot:activator="{ on }">
                                <v-btn x-small v-on="on" icon target="_blank" href="https://docs.tendertrace.com/guide/user-documentation/transparency-integrity-and-risk">
                                  <v-icon  small color="primary">mdi-information-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Past or present customers of {{ entity.name }} that are in my buyer clusters</span
                                >
                                <br />
                                Click the <v-icon small color="white">mdi-information-outline</v-icon> icon for more information.
                            </v-tooltip>
                            </v-card-title 
                          >
                          <v-card-subtitle>
                            <div class="font-weight-medium text-h6" style="color:#12253a;">
                              <a v-if="buyer_stats.cluster_buyers > 0"  
                              
                                :class="filterColour ('cluster_buyers')"
                                @click="selectedFilter = 'cluster_buyers', updateBuyerList({'supplier_id': [entity.id],
                                                            'result_filter': 
                                                              { 'filter_name': 'cluster_buyers', 
                                                                'filter_target_type': 'supplier', 
                                                                'filter_target_id': [entity.id]}})">
                              {{ growth_format(Math.round(buyer_stats.cluster_buyers / buyer_stats.total_buyers * 100)).change }}%</a>
                              
                              <span v-else>{{buyer_stats.cluster_buyers}}</span>
                              
                            </div>
                            <div class="font-weight-normal body-2" style="color:#12253a;">
                              {{ buyer_stats.cluster_buyers }}
                            </div>
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>
              <v-col cols="12" class="pt-0">
                  <profile-members 
                      :startIndex="0" 
                      :profile_id="entity.id"
                      :profile_name="entity.name"
                      :profile_type="'supplier'" 
                      :entity_type="'publisher'" 
                      :key="buyer_list_change"
                      :query="buyer_list_query.query"></profile-members>
              </v-col>
            </v-row>
        </v-tab-item>
        <v-tab-item>
            <v-row style="background-color:#f5f5f5">
            <v-col cols="12" class="pt-3">
                <profile-members 
                    :startIndex="1" 
                    :profile_id="entity.id" 
                    :profile_type="'supplier'" 
                    :profile_name="entity.name"
                    :entity_type="'category'"
                    :query="{'supplier_id': entity.id}"
                    ></profile-members>
            </v-col>
            </v-row>
        </v-tab-item>
        <v-tab-item v-if="entity && entity.entity_amendment_rollup">
            <v-row style="background-color:#f5f5f5">
            <v-col cols="12" class="pt-3">
                <v-card flat tile>
                  <v-card-text class="caption">
                    This analysis applies to Federal government contracts only. State and territory governments do not clearly articulate contract amendments. 
                    The analysis compares the relative value of the <b>first amendment</b> of the entity's contracts with the relative value of initial contract amendments in the market along with the relative duration between the start of the contract and the date of the first amendment.
                    Understanding these comparisons can provide an indication of the tendency of the entity to enter into the first amendment of a contract earlier than the norm, or for a higher relative value than the norm.
                  </v-card-text>
                </v-card>
                <amendment-analysis
                    :item="entity"
                    :entity_name="entity.name" 
                    ></amendment-analysis>
            </v-col>
            </v-row>
        </v-tab-item>
    </v-tabs>
    <v-dialog
      v-model="similar_dialog"
      max-width="500px"
      max-height="400px"
      hide-overlay
    >
      <v-card>
        <v-card-title class="subtitle-1 grey lighten-2">
          Similar companies to {{ entity.name }}
        </v-card-title>

        <v-card-text class="py-0">
          <v-list two-line>
            <v-list-item
              v-for="n in (entity.metadata && entity.metadata.competitors ? entity.metadata.competitors : [])"
              :key="n.name"
              class="py-0"
            >
              <v-list-item-content>
                <v-list-item-title class="my-0 py-0"
                  >{{ n.name }}
                  <!-- <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                  <template v-slot:activator="{ on }">
                    <router-link target="_blank" :to="{ name: 'search', query: { supplier: n.name, viewIndex:0 } }" v-on="on">
                      <v-btn right icon>
                        <v-icon medium color="secondary">mdi-magnify</v-icon>
                      </v-btn>
                    </router-link>
                  </template>
                  <span>Search this term</span>
                </v-tooltip> -->
                  </v-list-item-title
                >
                  <v-list-item-subtitle v-if="n.num_notices > 0" class="my-0 py-0 font-weight-normal subtitle-2">
                    <router-link target="_blank" :to="{ name: 'search', query: { supplier: n.name, viewIndex:0 } }" v-on="on">
                      Find related contracts
                      <v-icon color="#41a7d9" class="pl-0 ml-0"
                          >mdi-menu-right</v-icon
                        ></router-link>
                  </v-list-item-subtitle>
                <!-- <v-list-item-subtitle v-if="n.num_notices > 0" class="my-0 py-0">
                  <b>{{ n.num_notices }}</b> awards worth
                  <b>{{
                    formattedCurrency(n.award_total)
                  }}</b></v-list-item-subtitle
                >
                <v-list-item-subtitle v-else class="my-0 py-0">
                  <b>0 direct awards found</b></v-list-item-subtitle
                > -->
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" text @click="similar_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="info_dialog"
      max-width="500px"
      max-height="400px"
      hide-overlay
    >
      <v-card>
        <v-card-title class="subtitle-1 grey lighten-2">
          About {{ entity.name }}
        </v-card-title>

        <v-card-text class="py-2">
          {{ entity.metadata && entity.metadata.description ? entity.metadata.description : 'No description available' }}
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" text @click="info_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="related_dialog"
      max-width="500px"
      max-height="400px"
      hide-overlay
    >
      <v-card>
        <v-card-title class="subtitle-1 grey lighten-2">
          Other names for {{ entity.name }}
        </v-card-title>

        <v-card-text class="py-0">
          <v-list two-line>
            <v-list-item
              v-for="n in related_entities"
              :key="n"
              class="py-0"
            >
              <v-list-item-content>
                <v-list-item-title class="my-0 py-0"
                  >{{ n }}
                  </v-list-item-title
                >
                <v-list-item-subtitle class="my-0 py-0 font-weight-normal subtitle-2">
                    <router-link target="_blank" :to="{ name: 'search', query: { supplier: n, viewIndex:0 } }" v-on="on">
                      Find related contracts
                      <v-icon color="#41a7d9" class="pl-0 ml-0"
                          >mdi-menu-right</v-icon
                        ></router-link>
                  </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" text @click="related_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import {
  entitySearch,
  histogramSearch,
  fetchNews,
  executeSearch,
  buyerStats,
  fetchSupplierIntelligence,
  fetchSupplierSharedBuyers,
  fetchSupplierMarketOverlap,
  fetchSupplierCompetitiveComparison,
  fetchSupplierSharedBuyersWithRisk,
  fetchSupplierTargetingOpportunities,
  fetchSupplierAtRiskCustomers,
  fetchSupplierCompetitiveInsights
} from "../APIManager.js";
//import { Doughnut } from "vue-chartjs";
import { growth_format, numFormatter, formattedCurrency, govColor } from "../Utils.js";
import CompanyLogo from "../common/CompanyLogo.vue";
//import EntityTable from "../entities/EntityTable";
import SpendingTimeline from "../SpendingTimeline.vue";
//import CategoryTable from "../entities/CategoryTable";
import ProfileMembers from "../ProfileMembers.vue";
import ResultsTable from "../ResultsTable.vue";
import ResultsTableVuetify from "../ResultsTableVuetify.vue";
import SpendingDonut from "../SpendingDonut.vue";
import GraphDataView from "../GraphDataView.vue";
import ClusterSelect from "../ClusterSelect.vue";
import AmendmentAnalysis from "../AmendmentAnalysis.vue";

export default {
  components: {
    SpendingDonut,
    ResultsTableVuetify,
    SpendingTimeline,
    GraphDataView,
    ProfileMembers,
    ClusterSelect,
    AmendmentAnalysis,
    CompanyLogo
    //EntityTable,
    //CategoryTable
  },
  props: {
    entity: {},
    current_search: {},
    entity_id: String()
    //results_drawer: Boolean
  },
  data() {
    return {
      active_tab: 0,
      selectedFilter: 'all_entities',
      hit_info: {},
      related: [],
      tenders: [""],
      related_dialog: false,
      similar_dialog: false,
      info_dialog: false,
      alt_names_dialog: false,
      overlay: false,
      tabs: null,
      absolute: true,
      entity_panel: -9,
      entity_panels: [],
      panel_clicked: false,
      //current_index: 0,
      index: Number, //use the exp panel index as key so that we can cache the data
      profiles: [],
      mounted: false,
      entity_type: "supplier",
      total_amt_metric: "total_amount",
      search: {},
      category_aggs: [],
      date_aggs: [],
      publisher_aggs: [],
      contracting_activity: [],
      expiring_activity: [],
      expiry_aggs: [],
      gov_aggs: [],
      annual_spend: [],
      avg_contract: Number,
      following: false,
      industry: [],
      assessment_loaded: false,
      buyer_stats_loaded: false,
      metadata_loaded: false,
      assessment: {},
      buyer_stats: {},
      buyer_list_query: {"query": ""},
      supplier_list_change: Number,
      // Supplier Intelligence data
      supplier_intelligence: null,
      supplier_shared_buyers: null,
      supplier_market_overlap: null,
      supplier_competitive_comparison: null,
      supplier_shared_buyers_risk: null,
      supplier_targeting_opportunities: null,
      supplier_at_risk_customers: null,
      supplier_competitive_insights: null,
      intelligence_loading: false,
      show_insights_modal: false
    };
  },

  computed: {
    selected(){
      return [this.entity.id];
    },
    
    hasMetadata() {
      return this.entity && this.entity.metadata && this.metadata_loaded;
    }, 

    related_entities(){
      var related = [];
      if (this.entity.metadata && this.entity.metadata.otherNames && Array.isArray(this.entity.metadata.otherNames)){
        related = this.buildAltNames(this.entity.metadata.otherNames);
        related = this.removeIfPresent(related, this.entity.name)
      }

      if (this.entity.published_name){
        this.addIfNotPresent(related, this.entity.published_name)
      }
      return related;
    }
  },

  created() {
    
    //this.active_tab = this.$route.query.active_tab || 0;
  },

  mounted() {
    this.overlay = true;
    this.loadProfile();
    
  },

  watch: {
    $route(to, from) {
      //this.active_tab = this.$route.query.active_tab || 0;
    },

  },

  methods: {

    growth_format,
    numFormatter,
    formattedCurrency,

    filterColour(name) {
      return this.selectedFilter == name ? 'selected-link' : 'not-selected-link';
    },

    updateBuyerList(query){
      this.buyer_list_query.query = JSON.parse(JSON.stringify(query));
      this.buyer_list_change = Math.random() + Math.random() + Math.random();
    },

    buildAltNames(arr){
      var updatedArr = this.filterASCIIStrings(arr);
      return updatedArr;
    },

    filterASCIIStrings(arr) {
      return arr.filter(str => {
          return /^[\x00-\x7F]*$/.test(str);
      });
    },

    addIfNotPresent(arr, str) {
      if (!arr.includes(str)) {
          arr.push(str);
      }
      return arr;
    },

    removeIfPresent(arr, str) {
      if (arr.includes(str)) {
          arr.pop(str);
      }
      return arr;
    },

    getSizeText(maxSize){

      if (maxSize <= 1000){
        return "< 1000"
      }
      else if (maxSize <= 5000){
        return "< 5000"
      }
      else{
        return "5000+"
      }

    },

    searchSimilar(name) {
      var qry = {supplier: name, viewIndex:1};

      this.$router.push({ path: "/search", query: qry });
      //bus.$emit("load-filters", JSON.parse(query));
    },

    reset_aggs(){
      this.expiry_aggs = [];
      this.expiring_activity = [];
      this.date_aggs = [];
      this.contracting_activity = [];
      this.annual_spend = [];
      this.category_aggs = [];
      this.supplier_aggs = [];
    },

    async loadProfile() {
      
      this.search = { supplier_id: this.$route.params.id, size: 1 };
      
      // Run all loading methods in parallel and wait for them to complete
      await Promise.all([
        this.loadTenderAggs(),
        this.loadRecentAwards()
      ]);
      
      // Only hide overlay after all methods complete
      this.overlay = false;
    },

    async loadSupplierIntelligence() {
      this.intelligence_loading = true;
      const supplier_id = this.$route.params.id;
      //////console.log("Loading supplier intelligence for supplier_id:", supplier_id);
      
      try {
        const [
          intelligence, 
          sharedBuyers, 
          marketOverlap,
          competitiveComparison,
          sharedBuyersRisk,
          targetingOpportunities,
          atRiskCustomers,
          competitiveInsights
        ] = await Promise.all([
          fetchSupplierIntelligence(supplier_id).catch((err) => {
            //////console.error("Error fetching supplier intelligence:", err);
            return null;
          }),
          fetchSupplierSharedBuyers(supplier_id).catch((err) => {
            //////console.error("Error fetching supplier shared buyers:", err);
            return null;
          }),
          fetchSupplierMarketOverlap(supplier_id).catch((err) => {
            //////console.error("Error fetching supplier market overlap:", err);
            return null;
          }),
          fetchSupplierCompetitiveComparison(supplier_id).catch((err) => {
            //////console.error("Error fetching competitive comparison:", err);
            return null;
          }),
          fetchSupplierSharedBuyersWithRisk(supplier_id).catch((err) => {
            //////console.error("Error fetching shared buyers with risk:", err);
            return null;
          }),
          fetchSupplierTargetingOpportunities(supplier_id).catch((err) => {
            //////console.error("Error fetching targeting opportunities:", err);
            return null;
          }),
          fetchSupplierAtRiskCustomers(supplier_id).catch((err) => {
            //////console.error("Error fetching at-risk customers:", err);
            return null;
          }),
          fetchSupplierCompetitiveInsights(supplier_id).catch((err) => {
            //////console.error("Error fetching competitive insights:", err);
            return null;
          })
        ]);
        
        if (intelligence && intelligence.status === 'success') {
          this.supplier_intelligence = intelligence.data;
        }
        if (sharedBuyers && sharedBuyers.status === 'success') {
          this.supplier_shared_buyers = sharedBuyers.data;
        }
        if (marketOverlap && marketOverlap.status === 'success') {
          this.supplier_market_overlap = marketOverlap.data;
        }
        if (competitiveComparison && competitiveComparison.status === 'success') {
          this.supplier_competitive_comparison = competitiveComparison.data;
        }
        if (sharedBuyersRisk && sharedBuyersRisk.status === 'success') {
          this.supplier_shared_buyers_risk = sharedBuyersRisk.data;
        }
        if (targetingOpportunities && targetingOpportunities.status === 'success') {
          this.supplier_targeting_opportunities = targetingOpportunities.data;
        }
        if (atRiskCustomers && atRiskCustomers.status === 'success') {
          this.supplier_at_risk_customers = atRiskCustomers.data;
        }
        if (competitiveInsights && competitiveInsights.status === 'success') {
          this.supplier_competitive_insights = competitiveInsights.data;
        }
      } catch (error) {
        //////console.error("Error loading supplier intelligence:", error);
        // Silently fail - intelligence is optional
      } finally {
        this.intelligence_loading = false;
      }
    },

    async loadRecentAwards() {
      let results = {};

      try {
        //let labels = [];
        results = await executeSearch(
          JSON.stringify({
            supplier_id: this.$route.params.id,
            disposition: ['Contract Notice','Grant'],
            sort_field: "contract_start",
            size: 10
          })
        );

        //////////////////////console.log("TABLE RESULTS: ", results)

        this.tenders = results?.data || [];
        this.hit_info = results?.hits || {};
      } catch (error) {
        ////////console.error('Error loading recent awards:', error);
        this.tenders = [];
        this.hit_info = {};
      }
      // Don't set overlay = false here, let loadTenderAggs handle it
    },

    async loadTenderAggs() {
      //var results;
      //results = await executeSearch(this.search);
      //return results;

      this.loading_stats = true;

      try {
          const [histogramData, entityData] = await Promise.all([
              histogramSearch(this.search),
              entitySearch(this.search)
          ]);

          // Handle empty responses gracefully
          this.expiry_aggs = histogramData?.aggregations?.expiring?.buckets || [];
          this.expiring_activity = histogramData?.aggregations?.expiring_activity?.buckets || [];
          this.date_aggs = histogramData?.aggregations?.contracted?.buckets || [];
          this.contracting_activity = histogramData?.aggregations?.contracting_activity?.buckets || [];
          this.annual_spend = histogramData?.aggregations?.contracting_spend?.buckets || [];
          this.avg_contract = histogramData?.aggregations?.avg_contract_value?.value || 0;

          this.category_aggs = entityData?.aggregations?.major_category?.buckets || [];
          this.publisher_aggs = entityData?.aggregations?.publisher?.buckets || [];
          this.gov_aggs = entityData?.aggregations?.government?.buckets || [];
          
          // Set metadata as loaded
          this.metadata_loaded = true;
      } catch (error) {
          ////////console.error('Error fetching data:', error);
          // Set empty arrays on error
          this.expiry_aggs = [];
          this.expiring_activity = [];
          this.date_aggs = [];
          this.contracting_activity = [];
          this.annual_spend = [];
          this.avg_contract = 0;
          this.category_aggs = [];
          this.publisher_aggs = [];
          this.gov_aggs = [];
          this.metadata_loaded = true;
      } finally {
          this.loading_stats = false;
      }
    },

    async getBuyerStats(id) {
      if (this.buyer_stats_loaded == false){
        try {
          const data = await buyerStats(id);
          this.buyer_stats = data.data.buyer_stats;
          this.buyer_stats_loaded = true;
        } 
        catch (error) {
        }
      }
      else{
        return true;
      }
    },

    disableIcon(url) {
      if (!url) {
        return true;
      } else {
        return false;
      }
    },

    toggle() {
      this.watching = !this.watching;
      this.is_saved();
    },

    is_saved() {
      //////////////////////console.log("NOTIFY STATUS: " + this.current_search.notify)
      return this.watching;
    },

    govAvatarColor(gov) {
      return govColor(gov);  
    },

    async openInsightsModal() {
      this.show_insights_modal = true;
      // Load intelligence data when modal is opened
      if (!this.supplier_intelligence && !this.supplier_market_overlap && !this.supplier_competitive_comparison && !this.supplier_competitive_insights && !this.intelligence_loading) {
        await this.loadSupplierIntelligence();
      }
    },

    displayAdvantage(advantage) {
      if (typeof advantage === "string") {
        return advantage;
      }
      if (advantage && typeof advantage === "object") {
        return (
          advantage.title ||
          advantage.heading ||
          advantage.message ||
          advantage.description ||
          advantage.text ||
          JSON.stringify(advantage)
        );
      }
      return "";
    },

    extractPublisherIds(items) {
      if (!Array.isArray(items)) return [];
      const ids = items
        .map(item => item.publisher_id || item.buyer_id || item.buyer || item.publisher)
        .filter(Boolean);
      return Array.from(new Set(ids));
    },

    openSearchForPublishers(items) {
      const publisherIds = this.extractPublisherIds(items);
      if (publisherIds.length === 0 || !this.entity || !this.entity.id) {
        return;
      }
      const route = this.$router.resolve({
        name: "search",
        query: {
          viewIndex: 1,
          publisher_id: publisherIds,
          supplier_id: [this.entity.id]
        }
      });
      window.open(route.href, "_blank");
    }
  }
};
</script>

<style>

.selected-link {
    color: #ff4081 !important;
}

.not-selected-link {
    color: #12253a !important;
}

.chart {
  border-color: #424242 !important;
}

.headingUnderline {
  border-color: aqua !important;
}
</style>
